/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![NatureIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAByElEQVR4nNWUu0scURTGV8UiKqgRC1NYC9aCpBQEwTmPG7hzjq4S0ywRwcY/YBGrVEkjqGBhk1QihkiqNDYWQiCdlWKjiFGLiMT45C7rsiuZuTOrFl44MMMMv+87r5vJPIdjrW1Cks9AcgCg3Y8KD0zYgyy/kPXGBZBOPRwaBA0BDTGwrCLr9R28IMC6VBUUUV+h0Ukk+Q6kZ+XQSgH5mc7tm6EuJF1G1osoaIUAyUFSdg2y5oH0PAm4LP56ydbaOiBZTAm+a/KZ1zmQfqkGjklK5MasWji6IN2IK00zkP6JcHYFJN+A9CheRGYjBZD1fQT8H5owW/jH6ESsAKqJFiD58Z+mHQFLUMywyZUgpv6/rbUv4jLYvbc0X43JdrhvzKNtwLruKc8H39wXl0mOiWS41HgT9gLrjgd+aK19GSeQQZZTYNkMAtvp3vv7RxqR5SOQXnqnB8N3sfCCU5Y5orct7plIXvtdl/r0yQuvyMSEmuLuWcjn87WJ4WC0LwkcWE6AZCyV81wuV4+s255N3QeSmcHB4dZU8GJpsmVTceqmCVi3gGUNSKdddu4iTA0uCbCsFNMfrxqSiRXQeSDZG7C2/UkEnuLcAola48rjpzweAAAAAElFTkSuQmCC)
 */
export const NatureIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9.8 14.6c-.45.31-.9.6-1.37.89l-.02.01-1.15.73c-.85.57-1.68 1.2-2.4 2.1a7.75 7.75 0 0 0-.7 1.03c-.39.69-.7 1.48-.94 2.42a1 1 0 0 0 1.94.49c.12-.49.26-.9.42-1.28 1.98.08 9.05-.04 12.73-5.34 3.5-5.02 2.89-10.16 2.01-13.89-.19-.81-1.26-1-1.85-.42-1.8 1.8-3.69 2.32-5.67 2.86-2.34.63-4.8 1.3-7.35 4.15a9.13 9.13 0 0 0-2.13 8.7c.9-1.11 1.92-1.88 2.84-2.48.4-.28.8-.53 1.18-.76a13.7 13.7 0 0 0 3.55-2.83 1 1 0 1 1 1.52 1.3A13.44 13.44 0 0 1 9.8 14.6Z"
        className={colorClass}
      />
    </svg>
  );
};
